// src/components/ui/toast.jsx
import React, { useEffect } from 'react';
import { FiAlertTriangle, FiInfo, FiCheckCircle, FiX } from 'react-icons/fi';

const Toast = ({ message, type = 'info', onClose, duration = 5000, showCloseButton = true }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration]);

  const config = {
    error: { bg: 'bg-red-500/90 border-red-600', icon: FiAlertTriangle },
    warning: { bg: 'bg-amber-500/90 border-amber-600', icon: FiAlertTriangle },
    info: { bg: 'bg-brand-500/90 border-brand-600', icon: FiInfo },
    success: { bg: 'bg-accent-500/90 border-accent-600', icon: FiCheckCircle },
  };

  const { bg, icon: Icon } = config[type] || { bg: 'bg-surface-800 border-surface-700', icon: FiInfo };

  return (
    <div className={`fixed bottom-4 right-4 z-50 px-4 py-3 rounded-xl shadow-lg backdrop-blur-sm border-l-4 text-white ${bg} transition-all duration-300`}>
      <div className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Icon className="w-4 h-4 flex-shrink-0" />
          <span className="text-sm font-medium">{message}</span>
        </div>
        {showCloseButton && (
          <button onClick={onClose} className="text-white/80 hover:text-white transition-colors">
            <FiX className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Toast;
